import {getData} from "../api/get-data";

export const getNews = ({activePage = 1, resolveHandler}) => {
  getData({
    [`get_news`]: {
      [`page_num`]: String(activePage),
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
